/**
 * @file PublishAcknowledgeRow.tsx
 * @description Галочка «публикую с незакрытыми проверками» окна публикации
 * вида сайта (phase19.16, SB125; уточняет SB59, SB74, SB34/SB35).
 *
 * Текст собирается из того, чего не хватает: «На сайте нет: реквизитов
 * продавца, политики обработки персональных данных. Понимаю, что это
 * нарушает закон… — отвечаю за это я» (`acknowledgeText`). Ставит владелец
 * магазина или сотрудник с правом настроек (`SHOP_MANAGE_SETTINGS`);
 * остальным галочка недоступна с объяснением. Строка от 48 px (касание).
 */

import { CheckRow } from "../CheckRow";
import { acknowledgeText } from "../../../lib/site-view/publish-acknowledge";
import { ACKNOWLEDGE_FORBIDDEN_TEXT } from "../../../lib/site-view/errors";
import type { PublishCheck } from "../../../lib/site-view/types";

interface Props {
  /** Проверки уровня error, которые мешают публикации. */
  errors: PublishCheck[];
  checked: boolean;
  onChange: (value: boolean) => void;
  /** Есть право `SHOP_MANAGE_SETTINGS`. */
  allowed: boolean;
}

export function PublishAcknowledgeRow({ errors, checked, onChange, allowed }: Props) {
  return (
    // Флажок — у первой строки длинного текста, а не посередине абзаца: CheckRow
    // центрирует по строке, поправка — классом снаружи, сам CheckRow не меняется.
    <div className="flex flex-col gap-1 rounded-xl bg-destructive/8 px-3 py-1 [&>label]:items-start [&>label]:py-3 [&>label>[data-slot=checkbox]]:mt-[3px]">
      <CheckRow checked={allowed && checked} disabled={!allowed} onChange={onChange}>
        {acknowledgeText(errors)}
      </CheckRow>
      {allowed ? null : <p className="type-caption pb-2 pl-7 text-on-surface-variant">{ACKNOWLEDGE_FORBIDDEN_TEXT}.</p>}
    </div>
  );
}
